import { type MyStages, markStageDone, readMyStages, unmarkStage } from '@lib/my-stages'
import { useCallback, useState } from 'react'

// Registro de etapas hechas en este dispositivo (sin cuenta). `toggle` marca la etapa con la
// fecha de hoy o la desmarca si ya lo estaba.
export const useMyStages = (now: () => Date = () => new Date()) => {
	const [mine, setMine] = useState<MyStages>(() => readMyStages())
	const toggle = useCallback(
		(stageId: string) => setMine(stageId in readMyStages() ? unmarkStage(stageId) : markStageDone(stageId, now())),
		[now]
	)
	return { mine, toggle }
}
